import React, { useContext } from "react";
import styled from "styled-components";
import axios from "axios";
import Popup from "reactjs-popup";
import { ButtonGroup, Button as Bt } from "reactstrap";

import { dateConvertor, ToFixed, numberWithCommas } from "../../../Utils/util";
import Theme from "../../../Styles/Theme";
import Button from "../../Common/DefaultButton";
import GlobalContext from "../../../Hooks/globalContext";
import {
  HOST,
  CHAIN_ID,
  CHAIN_NAME,
  GAS_PRICE_API,
  NUMBER_REGEX,
  ETHERSCAN_TX_URL,
  ETHERSCAN_ADDRESS_URL,
  AMOUNT_REGEX,
} from "../../../Utils/constants";
import useState from "../../../Hooks/useState";
import Input from "../../Common/Input";
import TokenSelect from "../../Common/TokenSelect";
import useInput from "../../../Hooks/useInput";
import PopUp from "../PopUp";

const ButtonWrapper = styled.div`
  display: flex;
`;

const UpdateButton = styled.div`
  color: white;
  padding: 5px;
  background-color: orange;
  border-radius: 5px;
  text-align: center;
  :hover {
    cursor: pointer;
    opacity: 0.75;
  }
  :not(:last-child) {
    margin-right: 5px;
  }
`;

const BlueButton = styled(UpdateButton)`
  background-color: blue;
`;

const DeleteButton = styled(UpdateButton)`
  background-color: ${(props) => props.theme.navbar};
`;

const AnotherButton = styled(UpdateButton)`
  background-color: ${(props) => props.theme.mainColor};
`;

const OrangeButton = styled(UpdateButton)`
  background-color: orange;
`;

const DefaultButton = styled(UpdateButton)`
  background-color: ${(props) => props.theme.button};
  width: 70px;
`;

const DeleteForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
  color: ${(props) => props.theme.black};
`;

const DeleteLabel = styled.div`
  font-size: 20px;
  margin-bottom: 10px;
`;

const RedLabel = styled.span`
  color: red;
`;

const BlueLabel = styled.span`
  color: blue;
`;

const StrongSpan = styled.span`
  font-weight: bold;
`;

const QnaRow = styled.div`
  border-bottom: 1px solid grey;
  padding-bottom: 15px;
  margin-bottom: 15px;
  font-size: 13px;
`;

const BoldText = styled.div`
  font-weight: bold;
`;

const ColumnFactory = (params) => {
  const { httpHeader, modal, web3, getTxCount, getBalance, user, language } = useContext(GlobalContext);
  const pushTitleInput = useInput({ defaultValue: "", maxLength: 50 });
  const pushContentInput = useInput({ defaultValue: "", maxLength: 150 });
  const unit = useInput({ defaultValue: "", maxLength: 4, regex: NUMBER_REGEX });
  const lockAmount = useInput({ defaultValue: "", maxLength: 15, regex: AMOUNT_REGEX });
  const lockDay = useInput({ defaultValue: "", maxLength: 15, regex: NUMBER_REGEX });
  const chargePoint = useInput({ defaultValue: "", maxLength: 15 });
  const radioSelected = useState(null);
  const selected = useState(null);

  return {
    user: [
      {
        title: "번호",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "이메일",
        dataIndex: "email",
        key: "email",
      },
      {
        title: "이더지갑",
        dataIndex: "eth_wallet_address",
        key: "eth_wallet_address",
      },
      {
        title: "가입일",
        dataIndex: "created_at",
        key: "created_at",
        render: (item) => {
          return <>{dateConvertor(new Date(item))}</>;
        },
      },
      {
        title: "이메일인증여부",
        dataIndex: "email_confirmed",
        key: "email_confirmed",
        render: (item) => {
          return <>{item === 0 ? "X" : "O"}</>;
        },
      },
      {
        title: "포인트",
        dataIndex: "point",
        key: "point",
        render: (item) => <>{Number(item)} Point</>,
      },
      {
        title: "락업중(LCMS)",
        dataIndex: "locked_amount_lcms",
        key: "locked_amount_lcms",
        render: (item) => <>{Number(item).toFixed(2)} LCMS</>,
      },
      {
        title: "락업중(ESG)",
        dataIndex: "locked_amount_esg",
        key: "locked_amount_esg",
        render: (item) => <>{Number(item).toFixed(2)} ESG</>,
      },
      {
        title: "외부출금허용여부",
        dataIndex: "withdraw_status",
        key: "withdraw_status",
        render: (item) => (
          <>
            {item === "Y" ? <span style={{ color: "green" }}>허용</span> : <span style={{ color: "red" }}>불가</span>}
          </>
        ),
      },
      {
        title: "관리",
        render: (item) => {
          const deleteOnClick = async (close) => {
            const requestBody = {
              userId: item.id,
              action: "delete",
            };
            const { data } = await axios.post(`${HOST}/admin/users/crud`, requestBody, httpHeader());
            close();
            params.reset({ selected: params.nowPage.state });
          };

          const lockOnClick = async (close) => {
            if (lockAmount.value === "" || lockDay.value === "") {
              modal.setState("입력값이 없습니다.");
              return;
            }

            if (!selected.state) {
              modal.setState("입력값이 없습니다.");
              return;
            }

            if (isNaN(Number(lockAmount.value)) || isNaN(Number(lockDay.value)) || isNaN(Number(unit.value))) {
              modal.setState("숫자를 입력해주세요.");
              return;
            }

            if (Number(unit.value) > Number(lockDay.value)) {
              modal.setState("올바른 입력이 아닙니다.");
              return;
            }

            if (Number(lockDay.value) % Number(unit.value) !== 0) {
              modal.setState("올바른 입력이 아닙니다.");
              return;
            }

            const requestBody = {
              userId: item.id,
              eth_wallet_address: item.eth_wallet_address,
              amount: Number(lockAmount.value),
              day: Number(lockDay.value),
              unit: Number(unit.value),
              type: selected.state,
            };

            const { data } = await axios.post(`${HOST}/admin/users/lock`, requestBody, httpHeader());
            if (data.status) {
              close();
              lockAmount.setValue("");
              lockDay.setValue("");
              params.reset({ selected: params.nowPage.state });
              modal.setState("락업이 완료되었습니다.");
            }
          };

          const pushOnClick = () => {};

          // const pushOnClick = async (close) => {
          //   const requestBody = {
          //     userId: item.id,
          //     action: "push",
          //     title: pushTitleInput.value,
          //     content: pushContentInput.value,
          //   };
          //   const { data } = await axios.post(`${HOST}/admin/users/crud`, requestBody, httpHeader());
          //   pushTitleInput.setValue("");
          //   pushContentInput.setValue("");
          //   close();
          //   params.reset({ selected: params.nowPage.state });
          // };

          const chargeOnClick = async (close) => {
            if (chargePoint.value === "") {
              modal.setState("입력값이 없습니다.");
              return;
            }

            if (isNaN(Number(chargePoint.value))) {
              modal.setState("숫자를 입력해주세요.");
              return;
            }

            const requestBody = {
              userId: item.id,
              point: Number(chargePoint.value),
            };
            const { data } = await axios.post(`${HOST}/admin/users/charge`, requestBody, httpHeader());
            if (data.status) {
              close();
              chargePoint.setValue("");
              params.reset({ selected: params.nowPage.state });
              modal.setState("충전이 완료되었습니다.");
            }
          };

          const resetAuth = async ({ close, type }) => {
            const requestBody = {
              type,
              userId: item.id,
            };
            const { data } = await axios.post(`${HOST}/admin/user/resetauth`, requestBody, httpHeader());
            params.reset({ selected: params.nowPage.state });
            modal.setState("초기화가 완료되었습니다.");
            close();
          };

          const toggleWithdraw = async () => {
            const requestBody = {
              id: item.id,
              toggle: item.withdraw_status,
            };
            const { data } = await axios.post(`${HOST}/admin/withdraw/toggle`, requestBody, httpHeader());
            params.reset({ selected: params.nowPage.state });
            modal.setState("외부 출금 가능 상태가 변경되었습니다.");
          };

          return (
            <ButtonWrapper>
              <UpdateButton onClick={toggleWithdraw} style={{ backgroundColor: "indigo" }}>
                외부출금허용
              </UpdateButton>
              {user.state.isAdmin === 1 && (
                <>
                  {item.pushToken && (
                    <Popup
                      trigger={<UpdateButton>푸시</UpdateButton>}
                      modal={true}
                      contentStyle={{
                        padding: 25,
                        width: 300,
                        border: 0,
                        borderRadius: 10,
                      }}
                    >
                      {(close) => (
                        <DeleteForm>
                          <Input
                            placeholder={"푸시 제목"}
                            style={{ marginBottom: 10, color: "black", backgroundColor: "white" }}
                            {...pushTitleInput}
                          />
                          <Input
                            placeholder={"푸시 내용"}
                            style={{ marginBottom: 10, color: "black", backgroundColor: "white" }}
                            {...pushContentInput}
                          />
                          <Button
                            onClick={pushOnClick.bind(null, close)}
                            text={"전송"}
                            style={{ padding: "10px 15px" }}
                          />
                        </DeleteForm>
                      )}
                    </Popup>
                  )}
                  <Popup
                    trigger={<AnotherButton>{"충전"}</AnotherButton>}
                    modal={true}
                    contentStyle={{
                      padding: 25,
                      width: 300,
                      border: 0,
                      borderRadius: 10,
                    }}
                  >
                    {(close) => (
                      <DeleteForm>
                        <Input
                          placeholder={"충전할 포인트 (충전이 아닌 차감은 음수 입력)"}
                          style={{ marginBottom: 10, color: "black", backgroundColor: "white" }}
                          {...chargePoint}
                        />
                        <Button
                          onClick={chargeOnClick.bind(null, close)}
                          text={"충전"}
                          style={{ padding: "10px 15px", backgroundColor: Theme.mainColor }}
                        />
                      </DeleteForm>
                    )}
                  </Popup>
                  <Popup
                    onClose={() => {
                      selected.setState(null);
                    }}
                    trigger={<OrangeButton>{"락업"}</OrangeButton>}
                    modal={true}
                    contentStyle={{
                      padding: 25,
                      width: 300,
                      border: 0,
                      borderRadius: 10,
                    }}
                  >
                    {(close) => (
                      <DeleteForm>
                        <Input
                          placeholder={"락업 갯수"}
                          style={{ marginBottom: 10, color: "black", backgroundColor: "white" }}
                          {...lockAmount}
                        />
                        <Input
                          placeholder={"락업 시간 (일 단위)"}
                          style={{ marginBottom: 10, color: "black", backgroundColor: "white" }}
                          {...lockDay}
                        />
                        <TokenSelect type="lockup" selected={selected} />
                        <div style={{ color: "red", fontSize: 13, marginTop: 5, marginBottom: 5 }}>
                          락업 해제 단위를 30일로 지정했을 경우, 락업 시간은 30의 배수로 입력해야합니다.
                        </div>
                        <Input
                          placeholder={"락업 해제 단위(1, 30 둘중하나만 입력가능)"}
                          style={{ marginBottom: 10, color: "black", backgroundColor: "white" }}
                          {...unit}
                        />
                        <Button
                          onClick={lockOnClick.bind(null, close)}
                          text={"락업"}
                          style={{ padding: "10px 15px", backgroundColor: Theme.mainColor }}
                        />
                      </DeleteForm>
                    )}
                  </Popup>
                  <Popup
                    trigger={<DeleteButton>{"삭제"}</DeleteButton>}
                    modal={true}
                    contentStyle={{
                      padding: 25,
                      width: 300,
                      border: 0,
                      borderRadius: 10,
                    }}
                  >
                    {(close) => (
                      <DeleteForm>
                        <DeleteLabel>{"정말 삭제하시겠습니까?"}</DeleteLabel>
                        <Button
                          onClick={deleteOnClick.bind(null, close)}
                          text={"삭제"}
                          style={{ padding: "10px 15px" }}
                        />
                      </DeleteForm>
                    )}
                  </Popup>
                  <Popup
                    trigger={<DeleteButton style={{ backgroundColor: "blue" }}>{"초기화"}</DeleteButton>}
                    modal={true}
                    contentStyle={{
                      padding: 25,
                      width: 300,
                      border: 0,
                      borderRadius: 10,
                    }}
                  >
                    {(close) => (
                      <DeleteForm>
                        <DeleteLabel>{"비밀번호 초기화시 비밀번호는 12345678로 변경됩니다. "}</DeleteLabel>
                        <Button
                          onClick={resetAuth.bind(null, { close, type: "password" })}
                          text={"비밀번호 초기화"}
                          style={{ padding: "10px 15px", marginBottom: 10, backgroundColor: "green" }}
                        />
                        <Button
                          onClick={resetAuth.bind(null, { close, type: "otp" })}
                          text={"OTP 초기화"}
                          style={{ padding: "10px 15px", backgroundColor: "navy" }}
                        />
                      </DeleteForm>
                    )}
                  </Popup>
                </>
              )}
            </ButtonWrapper>
          );
        },
      },
    ],
    lockupList: [
      {
        title: "번호",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "락업 갯수",
        dataIndex: "lockup_amount",
        key: "lockup_amount",
        render: (item) => {
          return <>{numberWithCommas(Number(item))}</>;
        },
      },
      {
        title: "날짜",
        dataIndex: "created_at",
        key: "created_at",
        render: (item) => {
          return <>{item ? dateConvertor(new Date(item)) : "-"}</>;
        },
      },
      {
        title: "락업 해제일",
        dataIndex: "ended",
        key: "ended",
        render: (item) => {
          return <>{item ? dateConvertor(new Date(item)) : "-"}</>;
        },
      },
      {
        title: "락업된 토큰",
        dataIndex: "type",
        key: "type",
      },
      {
        title: "유저 지갑주소",
        dataIndex: "eth_wallet_address",
        key: "eth_wallet_address",
      },
      {
        title: "유저 이메일",
        dataIndex: "email",
        key: "email",
      },
      {
        title: "락업 단위(n일마다 풀림)",
        dataIndex: "lift_unit_day",
        key: "lift_unit_day",
        render: (item) => {
          return <>{item}</>;
        },
      },
      {
        title: "락업 기간",
        dataIndex: "lockup_days",
        key: "lockup_days",
        render: (item) => {
          return <>{item}</>;
        },
      },
      {
        title: "관리",
        render: (item) => {
          //   const requestBody = {
          //     id: item.id,
          //     toggle: item.lift_yn,
          //   };
          //   const { data } = await axios.post(`${HOST}/admin/lockup/toggle`, requestBody, httpHeader());
          //   modal.setState(item.lift_yn === "N" ? "락업이 해제되었습니다." : "락업이 복구되었습니다.");
          //   params.reset({ selected: params.nowPage.state });
          // };
          const toggle = async () => {
            const requestBody = {
              id: item.id,
            };
            const { data } = await axios.post(`${HOST}/admin/lockup/delete`, requestBody, httpHeader());
            modal.setState("락업이 해제되었습니다.");
            params.reset({ selected: params.nowPage.state });
          };

          return (
            <ButtonWrapper>
              {item.lift_yn === "N" && (
                <OrangeButton onClick={toggle} style={{ width: "auto" }}>
                  락업 강제 해제
                </OrangeButton>
              )}
            </ButtonWrapper>
          );
        },
      },
    ],

    // lockupList: [
    //   {
    //     title: "번호",
    //     dataIndex: "id",
    //     key: "id",
    //   },
    //   {
    //     title: "락업 갯수",
    //     dataIndex: "locked_amount",
    //     key: "locked_amount",
    //     render: (item) => {
    //       return <>{Number(item)}</>;
    //     },
    //   },
    //   {
    //     title: "날짜",
    //     dataIndex: "created_at",
    //     key: "created_at",
    //     render: (item) => {
    //       return <>{item ? dateConvertor(new Date(item)) : "-"}</>;
    //     },
    //   },
    //   {
    //     title: "락업 해제일",
    //     dataIndex: "release_time",
    //     key: "release_time",
    //     render: (item) => {
    //       return <>{item ? dateConvertor(new Date(item)) : "-"}</>;
    //     },
    //   },
    //   {
    //     title: "유저 번호",
    //     dataIndex: "user_id",
    //     key: "user_id",
    //   },
    //   {
    //     title: "유저 이메일",
    //     dataIndex: "email",
    //     key: "email",
    //   },
    //   {
    //     title: "관리",
    //     render: (item) => {
    //       const toggle = async () => {
    //         const requestBody = {
    //           id: item.id,
    //           toggle: item.status,
    //         };
    //         const { data } = await axios.post(`${HOST}/admin/lockup/toggle`, requestBody, httpHeader());
    //         modal.setState(item.status === 0 ? "락업이 해제되었습니다." : "락업이 복구되었습니다.");
    //         params.reset({ selected: params.nowPage.state });
    //       };

    //       return (
    //         <ButtonWrapper>
    //           {item.status === 0 ? (
    //             <OrangeButton onClick={toggle} style={{ width: "auto" }}>
    //               락업 강제 해제
    //             </OrangeButton>
    //           ) : (
    //             <DeleteButton onClick={toggle} style={{ width: "auto" }}>
    //               재 락업
    //             </DeleteButton>
    //           )}
    //         </ButtonWrapper>
    //       );
    //     },
    //   },
    // ],
    stakingList: [
      {
        title: "번호",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "스테이킹된 갯수",
        dataIndex: "staking_amount",
        key: "staking_amount",
        render: (item) => {
          return <>{Number(item)}</>;
        },
      },
      {
        title: "날짜",
        dataIndex: "created_at",
        key: "created_at",
        render: (item) => {
          return <>{item ? dateConvertor(new Date(item)) : "-"}</>;
        },
      },
      {
        title: "스테이킹 해제일",
        dataIndex: "release_time",
        key: "release_time",
        render: (item) => {
          return <>{item ? dateConvertor(new Date(item)) : "-"}</>;
        },
      },
      {
        title: "유저 번호",
        dataIndex: "user_id",
        key: "user_id",
      },
      {
        title: "지급 상태",
        dataIndex: "status",
        key: "status",
        render: (item) => {
          return <>{item === 0 ? <RedLabel>{"미지급"}</RedLabel> : <BlueLabel>{"지급"}</BlueLabel>}</>;
        },
      },
      {
        title: "보상 지급일",
        dataIndex: "reward_time",
        key: "reward_time",
        render: (item) => {
          return <>{item ? dateConvertor(new Date(item)) : "-"}</>;
        },
      },
      {
        title: "관리",
        render: (item) => {
          const toggle = async () => {
            const requestBody = {
              id: item.id,
              toggle: item.force_release,
            };
            const { data } = await axios.post(`${HOST}/admin/staking/toggle`, requestBody, httpHeader());
            modal.setState(item.status === 0 ? "스테이킹이 중단되었습니다." : "스테이킹이 복구되었습니다.");
            params.reset({ selected: params.nowPage.state });
          };

          return (
            <ButtonWrapper>
              {item.force_release === 0 ? (
                <OrangeButton onClick={toggle} style={{ width: "auto" }}>
                  스테이킹 강제중단
                </OrangeButton>
              ) : (
                <DeleteButton onClick={toggle} style={{ width: "auto" }}>
                  스테이킹 재개
                </DeleteButton>
              )}
            </ButtonWrapper>
          );
        },
      },
    ],
    mallList: [
      {
        title: "번호",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "제목",
        dataIndex: "title",
        key: "title",
      },
      {
        title: "내용",
        render: () => {
          return <>내용 확인</>;
        },
      },
      {
        title: "금액(원)",
        dataIndex: "price_krw",
        key: "price_krw",
        render: (item) => {
          return <>{Number(item)}</>;
        },
      },
      {
        title: "재고",
        dataIndex: "amount",
        key: "amount",
      },
      {
        title: "관리",
        render: (item) => {
          const updateOnClick = async () => {
            // params.adminPage.setState("registerProduct");
            params.focus.setState(item);
            params.page.setState("registerProduct");
          };

          const deleteOnClick = async () => {
            const requestBody = {
              id: item.id,
              action: "delete",
            };

            const { data } = await axios.post(`${HOST}/admin/product`, requestBody, httpHeader());
            params.reset({ selected: params.nowPage.state });
            modal.setState("상품이 삭제되었습니다.");
          };

          const stopOnClick = async () => {
            const requestBody = {
              id: item.id,
              isAvailable: item.is_available,
              action: "stop",
            };

            const { data } = await axios.post(`${HOST}/admin/product`, requestBody, httpHeader());
            params.reset({ selected: params.nowPage.state });
            modal.setState(item.is_available === "Y" ? "판매 중지 되었습니다." : "판매를 재개합니다.");
          };

          return (
            <ButtonWrapper>
              <BlueButton onClick={stopOnClick}>{item.is_available === "Y" ? "판매 중지" : "판매 재개"}</BlueButton>
              <UpdateButton onClick={updateOnClick}>수정</UpdateButton>
              <DeleteButton onClick={deleteOnClick}>삭제</DeleteButton>
            </ButtonWrapper>
          );
        },
      },
    ],
    mallOrder: [
      {
        title: "번호",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "주문인",
        dataIndex: "email",
        key: "email",
      },
      {
        title: "주문일",
        dataIndex: "created_at",
        key: "created_at",
        render: (item) => {
          return <>{item ? dateConvertor(new Date(item)) : "-"}</>;
        },
      },

      {
        title: "배송 주소",
        render: (item) => {
          return (
            <>
              {item.post_address} {item.post_address_detail}
            </>
          );
        },
      },
      {
        title: "상품명",
        dataIndex: "title",
        key: "title",
      },
      {
        title: "금액(원)",
        dataIndex: "price_krw",
        key: "price_krw",
        render: (item) => {
          return <>{Number(item)}</>;
        },
      },
      {
        title: "주문 수량",
        dataIndex: "product_amount",
        key: "product_amount",
        render: (item) => {
          return <>{Number(item)}</>;
        },
      },
      {
        title: "상태",
        dataIndex: "status",
        key: "status",
        render: (item) => {
          return (
            <span style={{ fontWeight: "bold", color: "navy" }}>
              {item === 0 && "주문 완료"}
              {item === 1 && "배송 준비"}
              {item === 2 && "배송 중"}
              {item === 3 && "배송 완료"}
            </span>
          );
        },
      },
      {
        title: "입금 금액",
        dataIndex: "amount",
        key: "amount",
        render: (item) => {
          return <>{numberWithCommas(ToFixed(item))}</>;
        },
      },
      {
        title: "입금 해시",
        dataIndex: "hash",
        key: "hash",
        render: (item) => {
          return (
            <UpdateButton
              onClick={() => {
                window.open(`${ETHERSCAN_TX_URL}${item}`);
              }}
            >
              확인
            </UpdateButton>
          );
        },
      },
      {
        title: "보낸 지갑",
        dataIndex: "send",
        key: "send",
        render: (item) => {
          return (
            <UpdateButton
              onClick={() => {
                window.open(`${ETHERSCAN_ADDRESS_URL}${item}`);
              }}
            >
              확인
            </UpdateButton>
          );
        },
      },
      {
        title: "받는 지갑",
        dataIndex: "receive",
        key: "receive",
        render: (item) => {
          return (
            <UpdateButton
              onClick={() => {
                window.open(`${ETHERSCAN_ADDRESS_URL}${item}`);
              }}
            >
              확인
            </UpdateButton>
          );
        },
      },
      {
        title: "입금 금액",
        dataIndex: "amount",
        key: "amount",
        render: (item) => {
          return <>{numberWithCommas(ToFixed(item))} LCMS</>;
        },
      },
      {
        title: "취소 여부",
        dataIndex: "is_cancel",
        key: "is_cancel",
        render: (item) => {
          return <>{item === "Y" ? <RedLabel>취소됨</RedLabel> : "-"}</>;
        },
      },
      {
        title: "취소일",
        dataIndex: "cancelled_at",
        key: "cancelled_at",
        render: (item) => {
          return <>{item ? dateConvertor(new Date(item)) : "-"}</>;
        },
      },
      {
        title: "관리",
        render: (item) => {
          const statusUpdate = async () => {
            if (radioSelected.state == null) {
              return modal.setState("변경할 상태를 선택해주세요.");
            }
            const requestBody = {
              id: item.id,
              status: radioSelected.state,
              action: "status",
            };

            const { data } = await axios.post(`${HOST}/admin/order`, requestBody, httpHeader());
            params.reset({ selected: params.nowPage.state });
            modal.setState("변경되었습니다.");
          };

          const stopOnClick = async () => {
            const requestBody = {
              id: item.id,
              isCancel: item.is_cancel,
              action: "stop",
            };

            const { data } = await axios.post(`${HOST}/admin/order`, requestBody, httpHeader());
            params.reset({ selected: params.nowPage.state });
            modal.setState(item.is_cancel === "N" ? "주문이 취소되었습니다." : "주문이 복구되었습니다.");
          };

          return (
            <ButtonWrapper>
              <PopUp text="상태 변경" style={{ width: 400, display: "flex", flexDirection: "column" }}>
                <ButtonGroup style={{ marginBottom: 15 }}>
                  <Bt color="primary" onClick={() => radioSelected.setState(0)} active={radioSelected.state === 0}>
                    주문 완료
                  </Bt>
                  <Bt color="primary" onClick={() => radioSelected.setState(1)} active={radioSelected.state === 1}>
                    배송 준비
                  </Bt>
                  <Bt color="primary" onClick={() => radioSelected.setState(2)} active={radioSelected.state === 2}>
                    배송 중
                  </Bt>
                  <Bt color="primary" onClick={() => radioSelected.setState(3)} active={radioSelected.state === 3}>
                    배송 완료
                  </Bt>
                </ButtonGroup>
                <UpdateButton onClick={statusUpdate}>상태 변경</UpdateButton>
              </PopUp>
              <DeleteButton onClick={stopOnClick}>{item.is_cancel === "Y" ? "주문 복구" : "주문 취소"}</DeleteButton>
            </ButtonWrapper>
          );
        },
      },
    ],
  };
};

export default ColumnFactory;
